import { Container } from "components"
import { PageIntentModule } from "components/modules/PageItent"
import { useEffect } from "react";
import { useAppDispatch } from "store/hooks";
import { setCurrentPage } from "store/slices/ui.slice";

export const PageIntent = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        window.analytics.page("PageIntent");
        dispatch(setCurrentPage('pageIntent'));
    }, []);

    return (
        <Container className="p-10 h-full overflow-hidden">
            <PageIntentModule />
        </Container>
    )
}